import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_APP102_Response, IAPI_APP104_Request } from "../../type/apiType";
import { httpAPI_APP102, httpAPI_APP104 } from "./api/request";
import { schema, tableList } from "./parts";
import { BusinessContext } from "../../context/businessContext";
import _ from "lodash";

/**
 * SCRW130001 通知メール
 * @return SCRW130001
 */
const SCRW130001 = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);

  const [stateTableList, setStateTableList] = useState(_.cloneDeep(tableList));
  const [resInit, setResInit] = useState<IAPI_APP102_Response>({});

  const [req, setReq] = useState<any>({});
  const [open, setOpen] = useState(false);

  const handleCallApiInit = async () => {
    // メール内容登録・更新表示API 呼び出し
    try {
      const res = await httpAPI_APP102({
        contractorNo: location.state?.contractorNo,
        applyId: location.state?.applyId,
      });

      if (res.resultCd === "I0000") {
        setResInit(res);

        let table = stateTableList;

        // 宛先
        table.find((item) => item.keyword === "mailAddress")!.text =
          res.mailAddress;

        //タイトル
        table.find((item) => item.keyword === "title")!.setDefaultValue =
          res.tempInfoList?.[0]?.title;

        // 本文
        table.find((item) => item.keyword === "text")!.setDefaultValue =
          res.tempInfoList?.[0]?.text;

        setStateTableList([...table]);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleCallApiInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const makeReq = (data: any): IAPI_APP104_Request => {
    const reqObj: IAPI_APP104_Request = {
      contractorNo: location.state?.contractorNo!,
      address: resInit.mailAddress,
      templateId: resInit.tempInfoList?.[0].tempId,
      title: data.title,
      text: data.text,
      applyId: location.state?.applyId,
      screenId: location.state?.screenId,
      emailId: resInit.tempInfoList?.[0].emailId,
      inquiryCode: location.state?.refInquiryScreen,
      reason: location.state?.memo,
    };

    if (businessState.common?.businessType === "JOB-73") {
      reqObj.applyDate = location.state?.contractDate;
    }

    return reqObj;
  };

  const handleSubmit = async (data: any) => {
    setReq(makeReq(data));
    setOpen(true);
  };

  const handleOk = async () => {
    // メール内容情報更新API 呼び出し
    try {
      const res = await httpAPI_APP104(req);

      if (res.resultCd === "I0000") {
        navigate("/SCRW110001");

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRW130001">
      <TkFakeTable
        list={stateTableList}
        ruleSchema={schema}
        buttonGroup={
          <TkBackButton
            useBackParam={true}
            navigateParam={{ applyId: location.state?.applyId }}
          />
        }
        submitButtonText="送信"
        onCheckAndSubmit={handleSubmit}
      />

      <TkMessageDialog
        open={open}
        onOky={handleOk}
        onCancel={() => setOpen(false)}
        title="確認（送信）"
        contextText="送信しますが、問題ないでしょうか。"
        cancelText="いいえ"
        okText="はい"
      />
    </Box>
  );
};

export default SCRW130001;
